"use client";
import React, { useActionState } from "react";
import { Form, FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import { Input } from "../ui/input";
import { SubmitButton } from "../ui/submit-button";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { login } from "@/services/auth.service";
import { useTranslations } from "next-intl";

const LoginForm = () => {
  const t = useTranslations();

  const form = useForm();
  const router = useRouter();
  const [state, formAction] = useActionState(login, {
    success: false,
    errors: {},
    message: null,
  });

  if (state.success && state.redirectTo) {
    router.push(state.redirectTo);
  }
  return (
    <>
      {state.message && !state.success && (
        <p className="text-red-500 text-sm">{t(state.message)}</p>
      )}

      <Form {...form}>
        <form action={formAction} className="space-y-5 mt-4">
          <FormField
            control={form.control}
            name="phone_number"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("phoneNumber")}</FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    placeholder="09XXXXXXXX"
                    type="tel"
                    autoFocus
                  />
                </FormControl>
                {state.errors.phone_number && (
                  <p className="text-red-500 text-sm">
                    {/* @ts-ignore */}
                    {t(state.errors.phone_number.toString())}
                  </p>
                )}
              </FormItem>
            )}
          />
          <SubmitButton className="w-full">{t("login")}</SubmitButton>
        </form>
      </Form>
    </>
  );
};

export default LoginForm;
